import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import BusinessDomainList from './pages/BusinessDomain/List';
import BusinessScenarioList from './pages/BusinessScenario/List';
import JudgeSetList from './pages/JudgeSet/List';
import UseCaseList from './pages/UseCase/List';
import JudgeScenarioList from './pages/JudgeScenario/List';
import MetricConfig from './pages/JudgeScenario/MetricConfig';
import JudgeTaskList from './pages/JudgeTask/List';
import ResultStats from './pages/JudgeTask/ResultStats';
import MachineAuditStats from './pages/JudgeTask/MachineAuditStats';
import AutoReviewResultStats from './pages/JudgeTask/AutoReviewResultStats';
import AutoReviewPreviewPage from './pages/JudgeTask/AutoReviewPreviewPage';
import BenchmarkList from './pages/Benchmark/List';
import BenchmarkDetail from './pages/Benchmark/Detail';
import ShadowReport from './pages/ShadowLink/Report';
import ShadowEvaluation from './pages/ShadowLink/Evaluation';
import AssertionConfig from './pages/ShadowLink/AssertionConfig';
import DataInsight from './pages/DataInsight/index';
import SkillInsight from './pages/SkillInsight/index';
import { WorkspaceProvider } from './contexts/WorkspaceContext';

function App() {
  const location = useLocation();
  const isDetailPage = (location.pathname.startsWith('/benchmark/') && location.pathname !== '/benchmark') ||
    location.pathname.startsWith('/result-stats/') ||
    location.pathname.startsWith('/machine-audit-stats/') ||
    location.pathname.startsWith('/auto-review-stats/') ||
    location.pathname.startsWith('/auto-review-preview/');

  return (
    <WorkspaceProvider>
      {isDetailPage ? (
        <Routes>
          <Route path="/benchmark/:id" element={<BenchmarkDetail />} />
          <Route path="/result-stats/:executionId" element={<ResultStats />} />
          <Route path="/machine-audit-stats/:executionId" element={<MachineAuditStats />} />
          <Route path="/auto-review-stats/:executionId" element={<AutoReviewResultStats />} />
          <Route path="/auto-review-preview" element={<AutoReviewPreviewPage />} />
        </Routes>
      ) : (
        <Layout>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/business-domain" element={<BusinessDomainList />} />
            <Route path="/business-scenario" element={<BusinessScenarioList />} />
            <Route path="/judge-set" element={<JudgeSetList />} />
            <Route path="/use-case" element={<UseCaseList />} />
            <Route path="/judge-scenario" element={<JudgeScenarioList />} />
            <Route path="/judge-scenario/metric-config/:scenarioId" element={<MetricConfig />} />
            <Route path="/judge-task" element={<JudgeTaskList />} />
            <Route path="/benchmark" element={<BenchmarkList />} />
            <Route path="/shadow-link/report" element={<ShadowReport />} />
            <Route path="/shadow-link/evaluation" element={<ShadowEvaluation />} />
            <Route path="/shadow-link/assertion-config" element={<AssertionConfig />} />
            <Route path="/data-insight" element={<DataInsight />} />
            <Route path="/skill-insight" element={<SkillInsight />} />
          </Routes>
        </Layout>
      )}
    </WorkspaceProvider>
  );
}

export default App;